import * as Yup from 'yup';

const accountCreatedSchema = Yup.object().shape({
    ftm_forename: Yup.string().required('First name is required'),
    ftm_surname: Yup.string().required('Last name is required'),
    ftm_email: Yup.string().email('Invalid email').required('Email is required'),
    ftm_contact_number: Yup.string().required('Phone number is required'),

    // Birthdate Validation with Age Check
    ftm_birth_of_date: Yup.date()
        .transform((value, originalValue) =>
            originalValue === "" ? null : value
        )
        .nullable()
        .required('Date of birth is required')
        .typeError('Invalid Date')
        .test('age', 'You must be at least 18 years old', function (value) {
            if (!value) return true; // Skip validation if no value
            const today = new Date();
            const birthDate = new Date(value);
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                return age >= 18; // Age is 18 or older
            }
            return age >= 18; // Age is 18 or older
        }),

    // Password Validation
    ftm_password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number'),
    // .matches(/[^a-zA-Z0-9]/, 'Password must contain at least one special character'),

    // Confirm Password Validation
    ftm_confirm_password: Yup.string()
        .oneOf([Yup.ref('ftm_password'), null], 'Passwords must match')
        .required('Confirm Password is required'),

    // Gender Validation
    ftm_gender: Yup.string()
        .required('Gender is required')
        .notOneOf(['0'], 'Please select a valid gender'),

    // Shirt size Validation
    ftm_t_shirt_size: Yup.string()
        .required('Shirt size is required')
        .notOneOf(['0'], 'Please select a valid shirt size'),
});

export default accountCreatedSchema;
